import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Settings, Globe } from "lucide-react";
import { showToast } from '@/utils/toast';

const PersonalizationModal = React.memo(({ 
  isOpen, 
  onClose,
  language,
  onLanguageChange
}) => {
  const [localLanguage, setLocalLanguage] = useState(language);

  const handleSave = () => {
    if (localLanguage !== language) {
      onLanguageChange(localLanguage);
    }
    showToast.success("Tercihleriniz kaydedildi");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" aria-label="Kişiselleştirme">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Kişiselleştirme
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <Card className="p-4 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="language" className="flex items-center gap-2">
                <Globe className="h-4 w-4" />
                Dil
              </Label>
              <Select value={localLanguage} onValueChange={setLocalLanguage}>
                <SelectTrigger id="language">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="tr">Türkçe</SelectItem>
                  <SelectItem value="en">English</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </Card>
          
          <div className="flex gap-2">
            <Button onClick={handleSave} className="flex-1">
              Kaydet
            </Button>
            <Button variant="outline" onClick={onClose}>
              İptal
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
});

PersonalizationModal.displayName = 'PersonalizationModal';

export default PersonalizationModal;
